import React from 'react';
import i18n from 'i18next';

// Import components
import TagsForm from '../../tags_form/TagsForm';

export const tagsTabs = [
	{
		name: i18n.t('common:tabs.metadata'),
		path: 'metadata',
		disableOnCreate: false,
		component: <TagsForm />
	}
];
